import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { RouteLocationNormalized } from "vue-router";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { mapCountryIdentifiersToIso } from "@app/utils/country-identifiers";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if(typeof to.query?.[FilterType.COUNTRY] === 'undefined') return;
	const identifiers = (to.query[FilterType.COUNTRY] as string).split(',');
	const { identifiers: isoCodes, hasChanged } = mapCountryIdentifiersToIso(identifiers);

	if(!hasChanged) return;

	to.query[FilterType.COUNTRY] = isoCodes.join(',');
	return navigateTo(to, { replace: true });
});
